import { render, staticRenderFns } from "./TagGroups.vue?vue&type=template&id=c8847724"
import script from "./TagGroups.vue?vue&type=script&lang=js"
export * from "./TagGroups.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports